import { computed } from 'vue-demi';
import { useRouter } from '@/composables';

export const useSessionViewsRouter = () => {
  const { AppRouter, query } = useRouter();

  const activeSessionViewId = computed(() => {
    return query.value[AppRouter.QUERY_PARAMS.FILTER_ID] as string;
  });

  const setActiveSessionViewId = (viewId: string) => {
    AppRouter.appendQuery({
      query: {
        [AppRouter.QUERY_PARAMS.FILTER_ID]: viewId,
      },
    });
  };

  return { activeSessionViewId, setActiveSessionViewId };
};
